export { DocumentsPaths } from './paths'
